import { createFileRoute } from '@tanstack/react-router';

import { revalidateLocationCapabilities } from 'shared/modules/capabilities';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/lsg')({
  staticData: { breadcrumb: 'localSearchGrid' },
  // The pages' gate reads the location capabilities; refreshing them here keeps the pages from rendering
  // empty or from stale access first.
  loader: ({ context: { queryClient }, params: { id } }) =>
    revalidateLocationCapabilities({ queryClient, locationId: id })
});
